import React               from 'react'
import PropTypes           from 'prop-types'
import { withRouter      } from 'react-router'
import { Row, Col, Alert } from 'react-bootstrap'

import { isValidEmail          } from 'alto-utils/lib/utils'
import { Panel, HorizontalForm } from 'alto-react-components/lib/components'
import { contactFormSetting    } from 'alto-react-client-auth/lib/settings'

import './contact_form.sass'

class ContactForm extends React.Component
  @contextTypes =
    auth:     PropTypes.object
    backend:  PropTypes.object
    settings: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    setting = contactFormSetting(context.settings)

    unless setting.enabled
      @disabled = true
      return props.history.replace('/')

    if context.auth.isLoggedIn
      email      = context.auth.loggedInUser.email
      cardNumber = context.auth.loggedInClient.cardId

    @state =
      cardNumber: cardNumber or ''
      email:      email      or ''
      subject:    ''
      message:    ''
      category:   setting.categories[0]
      categories: setting.categories
      success:    null
      error:      null
      sent:       false

  render: ->
    return null if @disabled

    if @state.categories
      content =
        <Panel id='contact-panel' header='Kontaktujte nás' bsStyle='info'>
          {@alert()}
          {@form()}
        </Panel>
    else
      content = <Alert id='contact-alert'>Načítám</Alert>

    <Row>
      <Col xs={12}>
        {content}
      </Col>
    </Row>

  alert: ->
    <React.Fragment>
      {<Alert bsStyle='success'>{@state.success}</Alert> if @state.success}
      {<Alert bsStyle='danger'>{@state.error}</Alert> if @state.error}
    </React.Fragment>

  form: ->
    <HorizontalForm>
      {@cardNumberInput()}
      {@replyEmailInput()}
      {@categorySelect()}
      {@subjectInput()}
      {@messageInput()}
      {@submitButton()}
    </HorizontalForm>

  cardNumberInput: ->
    <HorizontalForm.Control label='Číslo věrnostní karty'
     value={@state.cardNumber}
     valid={@state.cardNumber.length}
     onChange={(value) => @setState(cardNumber: value)} />

  replyEmailInput: ->
    <HorizontalForm.Control label='Kontaktní email'
     type='email'
     value={@state.email}
     valid={isValidEmail(@state.email)}
     onChange={(value) => @setState(email: value)} />

  categorySelect: ->
    <HorizontalForm.Select label='Kategorie'
     value={@state.category}
     options={@state.categories.map (c) -> [c, c]}
     onChange={(value) => @setState(category: value)} />

  subjectInput: ->
    <HorizontalForm.Control label='Předmět'
     value={@state.subject}
     valid={@state.subject.length}
     onChange={(value) => @setState(subject: value)} />

  messageInput: ->
    rows = @state.message.split('\n').length

    <HorizontalForm.TextArea id='contact-message' label='Vaše zpráva'
     value={@state.message}
     rows={Math.max(rows, 3)}
     valid={@state.message.length}
     onChange={(value) => @setState(message: value)} />

  submitButton: ->
    <HorizontalForm.Button id='contact-submit'
     caption={if @state.sent then 'Odesláno' else 'Odeslat'}
     bsStyle={if @state.sent then 'success'  else 'primary'}
     onClick={@submit.bind(@)}
     disabled={@state.sent or !@isValid()} />

  submit: ->
    body = { ..._.pick(@state, 'category', 'subject', 'message'), \
             reply_to: @state.email, card_number: @state.cardNumber }

    @context.backend.request('POST', '/mailing/send_support_email', body: body)
      .then          => @setState(success: 'Vaše zpráva byla úspěšně odeslána.', error: null, sent: true)
      .catch (error) => @setState(success: null, error: 'Došlo k chybě: ' + JSON.stringify(error.data))

  isValid: ->
    @state.cardNumber.length and isValidEmail(@state.email) and
      @state.subject.length and @state.message.length

export default withRouter(ContactForm)

export IfContactFormEnabled = ({ children }, { settings }) ->
  setting = contactFormSetting(settings)

  if setting.enabled then children else null

IfContactFormEnabled.contextTypes = { settings: PropTypes.object }
